import React from 'react';
import { Redirect } from "react-router-dom";

import TextField from '../Molecules/TextField';
import NumberField from '../Molecules/NumberField';
// import SelectField from '../Molecules/SelectField';
import SingleNextButton from '../Atoms/SingleNextButton';
import InvalidFeedback from '../Atoms/InvalidFeedback';
import StepShell from '../StepComponents/StepShell';
import Form from '../StepComponents/Form';
import { getApp, setApp, addBalanceTransferObject, editBalanceTransferObject, deleteBalanceTransferObject, resetBalanceTransferObject } from '../../index';
import { currencyRegex} from '../../Utils/ValidationPatterns';
// import { usStates } from '../../Utils/SelectOptions';

export class StepBalanceTransfer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            balanceTransfer: ''
        };
    }
    
    componentDidMount() {

        var existingBalanceTransferValue = getApp('balanceTransfer');

        if (existingBalanceTransferValue !== "") {

            this.setState({ balanceTransfer: existingBalanceTransferValue });

            var bTRadioId;

            if (existingBalanceTransferValue === "yes") {
                bTRadioId = "balanceTransferYes";
            }
            if (existingBalanceTransferValue === "no") {
                bTRadioId = "balanceTransferNo";
            }

            document.getElementById(bTRadioId).checked = true;
        }

        resetBTInfo();
    }

    checkBalanceTransfer(event) {
        var newState = event.target.value;
        this.setState({ balanceTransfer: newState });
        setApp('balanceTransfer', newState);
        if (newState === 'no') {
            resetBTInfo();
            resetBalanceTransferObject();
            this.props.history.push('/loan-application/disclosures');
        } else {
            this.props.history.push('/loan-application/balance-transfer-info');
        }
    }

    render() {

        let backLink = '/loan-application/authorized-user';
        let NextButton;
        let nextLink;
        let btCount = getApp('balanceTransferArray').length;
        let asCount = getApp('authorizedUserArray').length;
        let bt = this.state.balanceTransfer;

        if(asCount > 0)
            backLink = '/loan-application/authorized-user-detail';
        
        if (btCount > 0 && bt === 'yes') {
            NextButton = (
                <SingleNextButton nextBtnTxt="View Transfers" />
            );
            nextLink = '/loan-application/balance-transfer-detail';
        }
        
        if (btCount === 0 && bt === 'no') {
            NextButton = (
                <SingleNextButton nextBtnTxt="Next" />
            );
            nextLink = '/loan-application/disclosures';
        }

        return (
            <StepShell stepID="StepBalanceTransfer"
                friendlyText="One more thing..."
                requestText="Would you like to transfer balances from other credit cards?"
                progress="85%"
                backLink={backLink}
                progressLabel="Balance Transfer"
            >
                <Form nextLink={nextLink}>
                    <div className="loanApp-radio-buttons hug" onChange={this.checkBalanceTransfer.bind(this)}>
                        <div className="loanApp-form-row">
                            <div className=" col col-6 loanApp-radio">
                                <input type="radio" name="balanceTransfer" value="yes" className="pull-left loanApp-form-control" id="balanceTransferYes" />
                                <label htmlFor="bTYes">YES</label>
                                <InvalidFeedback feedback="invalid" />
                            </div>
                            <div className="col col-6 loanApp-radio">
                                <input type="radio" name="balanceTransfer" value="no" className="pull-left loanApp-form-control" id="balanceTransferNo" />
                                <label htmlFor="bTNo">NO</label>
                                <InvalidFeedback feedback="invalid" />
                            </div>
                        </div>
                        <div className="loanApp-form-row">
                            <div className=" col col-12">
                                <BalanceTransferDisclosure />
                            </div>
                        </div>
                        {NextButton}
                    </div>
                </Form>
            </StepShell>
        )
    }
}

export class StepBalanceTransferDetail extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        let headTitle = 'You can transfer balances from up to three credit cards';
        let subTitle = '';
        let btCount = getApp('balanceTransferArray').length;

        if(btCount < 1) {
            subTitle = '';
        }
        else if (btCount >= 1 && btCount < getApp('btMax')) {
            subTitle = 'Would you like to transfer another balance?';
        } else if (btCount === getApp('btMax')) {
            subTitle = '';
        }

        return (
            <StepShell stepID="StepBalanceTransferDetail"
                friendlyText={headTitle}
                requestText={subTitle}
                progress="85%"
                backLink="/loan-application/balance-transfer"
                progressLabel="Balance Transfer"
            >
                <Form nextLink="/loan-application/disclosures">
                    <div className="loanApp-radio-buttons hug">
                        <div className="loanApp-form-row">
                            <BalanceTransfer />
                        </div>
                    </div>
                </Form>
            </StepShell>
        )
    }
}


class BalanceTransfer extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            fireRedirect: false,
            btArray: getApp('balanceTransferArray')
        };
    }
    
    addBalanceTransfer(event) {
        event.preventDefault();
        var currentBTCounter = getApp('btCounter');
        setApp('btCounter', currentBTCounter += 1);
        this.setState({ fireRedirect: true });
        window.scrollTo(0, 0);
    }
    
    render() {

        let btArray = this.state.btArray;
        let btSummary;
        let NextButton;
        let AddButton = (
            <button id="addBalanceTransfer" className="next-btn button" type="submit" onClick={this.addBalanceTransfer.bind(this)}>Add</button>
        );

        if(btArray.length > 0) {
            btSummary = (
                btArray.map((bt) => {
                    return (
                        <BalanceTransferReview 
                            key={bt.Id}
                            BTKey={bt.Id}
                            LenderName={bt.LenderName}
                            // LenderAccount={bt.LenderAccount}
                            LenderAmount={bt.LenderAmount}
                        />
                    )
                })
            );
            if(btArray.length >= getApp('btMax')) {
                AddButton = <span></span>
            }
            NextButton = (
                <SingleNextButton nextBtnTxt="Next" />
            );

        } else {
            btSummary = (
                <span></span>
            );

            NextButton = (
                <span></span>
            );
        }

        return (
            <div>
                {btSummary}
                <div className="hug loanApp-btn-wrap single-next">
                    {AddButton}
                    {this.state.fireRedirect && (
                        <Redirect to="/loan-application/balance-transfer-info"/>
                    )}
                </div>
                {NextButton}
            </div>
        )
    }
}

class BalanceTransferReview extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            fireRedirect: false,
        };
    }

    editClick = (e) => {
        e.preventDefault();
        this.setState({ fireRedirect: true });
        window.scrollTo(0, 0);
    }
    
    render() {
        return (
            <div className="step-review">
                <button className="edit-button" onClick={this.editClick} >Edit</button>
                {this.state.fireRedirect && (
                    <Redirect to={{
                        pathname: `/loan-application/balance-transfer-info`, 
                        state: {
                            btId: this.props.BTKey
                        }}} />
                )}
                <span>Lender Name: <strong>{this.props.LenderName}</strong><br /></span>
                {/* <span>Credit Card Number: <strong>{this.props.LenderAccount}</strong><br /></span> */}
                <span>Transfer Amount: <strong>{this.props.LenderAmount}</strong><br /></span>
            </div>
        )
    }
}

export class StepBalanceTransferInfo extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            fireRedirect: false
        };
    }
    
    saveBalanceTransferInfo(e) {
        e.preventDefault();
        this.setState({ fireRedirect: true });
        saveBTInfo();
        window.scrollTo(0, 0);
    }

    deleteBalanceTransfer(e) {
        e.preventDefault();
        this.setState({ fireRedirect: true });
        deleteBTInfo();
        window.scrollTo(0, 0);
    }
    
    render() {
        
        let btId;
        let btDeleteButton;
        
        if(this.props.location.state !== undefined){
            btId = this.props.location.state.btId;
            btDeleteButton = (
                <button id="deleteBalanceTransfer" className="next-btn button" onClick={this.deleteBalanceTransfer.bind(this)}>Delete</button>
            )
        }

        return (
            <StepShell stepID="StepBalanceTransferInfo"
                friendlyText="About your balance transfer"
                requestText=""
                progress="85%"
                backLink="/loan-application/balance-transfer"
                progressLabel="Balance Transfer"
            >
            <form className="loanApp-form" onSubmit={this.saveBalanceTransferInfo.bind(this)} >
                <BalanceTransferInfo btIndex={btId} />
                <div className="hug loanApp-btn-wrap single-next">
                    <button id="addBalanceTransfer" className="next-btn button" type="submit">Save</button>
                    {btDeleteButton}
                    {this.state.fireRedirect && (
                        <Redirect to="/loan-application/balance-transfer-detail"/>
                    )}
                </div>
            </form>
            </StepShell>
        )
    }
}

class BalanceTransferInfo extends React.Component {
    
    componentDidMount() {
        if(this.props.btIndex !== undefined && getApp('balanceTransferArray').length > 0){
            var currentBTInfo = getApp('balanceTransferArray').find(bt => bt.Id === this.props.btIndex);
            setApp('btLenderName', currentBTInfo.LenderName);
            //setApp('btCreditCardNumber', currentBTInfo.LenderAccount);
            setApp('btTransferAmount', currentBTInfo.LenderAmount);
            // setApp('btLenderAddress', currentBTInfo.Address);
            // setApp('btLenderCity', currentBTInfo.City);
            // setApp('btLenderState', currentBTInfo.State);
            // setApp('btLenderState_label', usStates.find(state => state.value === currentBTInfo.State).name);
            // setApp('btLenderZip', currentBTInfo.ZipCode);
            setApp('btIndex', this.props.btIndex);
        } else {
            setApp('btIndex', getApp('btCounter'));
        }
    }

    render() {
        return (
            <div>
                <TextField name="btLenderName" label="Lender Name" required={true} />
                {/* <NumberField name="btCreditCardNumber" min={13} max={19} pattern={creditCardRegex} format="###################" label="Credit Card Number" required={true} /> */}
                <span className="dropdown-text">How much would you like to transfer?</span>
                <NumberField name="btTransferAmount" prefix="$" pattern={currencyRegex} label="Amount" required={true} />
                {/* <div>
                    <span className="dropdown-text">What is the lender's payment address for this credit card?</span>
                    <br />(Located on your credit card statement)
                <TextField name="btLenderAddress" label="Address" required={true} />
                </div>
                <TextField name="btLenderCity" label="City" required={true} />
                <div className="loanApp-form-row">
                    <div className="col col-6">
                        <SelectField options={usStates} required={true} name="btLenderState" placeholder="State" labelType="hidden"
                        />
                    </div>
                    <div className="col col-6">
                        <NumberField name="btLenderZip" pattern={zipRegex} format="#####" label="Zipcode" required={true} />
                    </div>
                </div> */}
            </div>
        )
    }
}

class BalanceTransferDisclosure extends React.Component {
    
    render() {
        var divStyle = {
            "fontSize": "0.70rem",
            "marginTop": "15px"
        };

        return (
            <div className="p-sm" style={divStyle}>
                <p>
                    No balance transfer fee. You should allow at least 14 business days from account opening for a balance transfer to be completed. Continue to make payments on your other accounts until you have confirmed this balance transfer has been received. Once approved, we'll pay the amount of the balance transfer directly to that issuer. You may transfer any amount, up to your available credit for transfers, which may be less than your total credit line. If your balance transfer request will exceed your available credit, we will process your transfers for less than the amount requested, in the order requested. You may only make balance transfers to accounts that list you as an account holder. Balance transfers may not be used to pay any Vantage West accounts and do not earn rewards.
                </p>
            </div>
        )
    }
}

function resetBTInfo() {
    setApp('btIndex', -1);
    setApp('btLenderName', "");
    // setApp('btCreditCardNumber', "");
    setApp('btTransferAmount', "");
    // setApp('btLenderAddress', "");
    // setApp('btLenderCity', "");
    // setApp('btLenderState', "");
    // setApp('btLenderState_label', "");
    // setApp('btLenderZip', "");
}

function saveBTInfo() {
    let btIndex = getApp('btIndex');
    let targetBTObjectIndex = getApp('balanceTransferArray').findIndex(bt => bt.Id === btIndex);
    if(targetBTObjectIndex === -1) {
        addBalanceTransferObject();
    } else {
        editBalanceTransferObject(targetBTObjectIndex);
    }
    resetBTInfo();
}

function deleteBTInfo() {
    let btIndex = getApp('btIndex');
    let targetBTObjectIndex = getApp('balanceTransferArray').findIndex(bt => bt.Id === btIndex);
    deleteBalanceTransferObject(targetBTObjectIndex);
    resetBTInfo();
}